import { ChartsContainer } from '@anytag/shared-atoms';
import { getValuableVariables } from '@anytag/shared-utils';
import { useFacebookPageAnalyticsAudienceQuery } from '@anytag/graphql';
import { useQueryHelper } from '@anytag/shared-hooks';
import { AgeBreakdownChart, AreaBreakdownChart, GenderBreakdownChart } from '@anytag/shared-molecules';
import { AnalyticsAudienceWrapper } from '../../shared';
import { AnalyticsSelectedAccountInfo } from '../../types';
import { useAnalyticsProfileSearch } from '../../hooks';

export interface AnalyticsFacebookDashboardAudienceProps {
  analyticsAccount: AnalyticsSelectedAccountInfo;
}

export const AnalyticsFacebookDashboardAudience = ({ analyticsAccount }: AnalyticsFacebookDashboardAudienceProps) => {
  const { t, navigate, enqueueSnackbar } = useQueryHelper();
  const { filter } = useAnalyticsProfileSearch();
  const { data, loading } = useFacebookPageAnalyticsAudienceQuery({
    fetchPolicy: 'cache-first',
    variables: getValuableVariables({
      endDate: filter.endDate,
      startDate: filter.startDate,
      facebookPageAnalyticsAccountId: analyticsAccount.id
    }),
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
      navigate({ to: '/analytics' });
    }
  });

  return (
    <AnalyticsAudienceWrapper loading={loading} data={data?.facebookPageAnalyticsAudience}>
      {({ data: { ageRate, genderRate, regionRate } }) => (
        <ChartsContainer
          css={{ height: '385px' }}
          elements={[
            <GenderBreakdownChart {...genderRate} />,
            <AgeBreakdownChart {...ageRate} />,
            <AreaBreakdownChart avatar={analyticsAccount.avatar} followerRegionRate={regionRate} />
          ]}
        />
      )}
    </AnalyticsAudienceWrapper>
  );
};
